module.exports = __webpack_public_path__ + "media/images/report_areas/gaic-04e43fa0b1890795ef12e2f015c1b304.png";